import axios from "axios";
import config from "./config";
import { getToken, removeToken } from "@/utils/auth";
import { Message } from "element-ui";
export default function $axios(options) {
  return new Promise((resolve, reject) => {
    const instance = axios.create({
      baseURL: config.baseUrl + "" + options["act"],
      headers: config.headers,
      timeout: config.timeout,
      withCredentials: config.withCredentials,
    });
    instance.interceptors.request.use(
      (config) => {
        // if (store.getters.token) {
        var token = getToken();
        if (token && token != "null") config.headers["token"] = getToken();
        // }
        //获取当前的毫秒级时间戳
        var timestamp = Date.now();
        
        //生成4位随机数
        var random = Math.floor(Math.random() * 10000);
          random = random.toString().padStart(4, '0');
        //取时间戳前面3位+随机数+时间戳后面3位
        var timestampRandom = timestamp.toString().substring(0, 3) + random + timestamp.toString().substring(3, 13);
        //将时间戳随机数赋值给headers
        config.headers["ts"] = timestampRandom;
         
        
        return config;
      },
      (error) => {
        // do something with request error
        console.log(error); // for debug
        return Promise.reject(error);
      }
    );
    instance.interceptors.response.use((response) => {
      let data;
 
      if (response.data == undefined) {
        data = JSON.parse(response.request.responseText);
      } else {
        data = response.data;
      }
      // console.log(data);   
      return data;
    });

    instance(options)
      .then((res) => {
        // console.log(res);
        if (res.message == "Token不匹配") {
          removeToken();
          // Message({
          //   message: "登陆超时，请重新登录" || "Error",
          //   type: "error",
          // });

          location.reload();
        } else {
          resolve(res);
        }
        return false;
      })
      .catch((error) => {
        reject(error);
      });
  });
}
